import { clientWithApiClient } from "../../client";
import type { ApiClient, ListResponse } from "../../types";
import type { AcceptanceDocument } from "./types";

/**
 * Lists the mandatory (checkbox) documents a customer must accept before a
 * soft hold can be created for this vehicle (fleet-agreement-acceptance,
 * path 1's read side).
 *
 * `GET /v1/vehicles/:vehicle_id/acceptance-documents` accepts either a fleet
 * user session or an API key — but an API key only succeeds if it has been
 * explicitly granted permission for this path. `FmsApi.Plugs.AuthorizeApiKey`
 * checks an exact per-key allowlist row; adding this route to the server does
 * not retroactively grant it to keys created earlier. A widget key that only
 * has permissions for `/vehicles/:id`, `/soft-holds`, etc. gets a 403 here
 * until a fleet admin adds this path to that key's permissions.
 */
const list = (apiClient: ApiClient, vehicleId: string) => {
  return clientWithApiClient<ListResponse<AcceptanceDocument>>(
    apiClient,
    `/vehicles/${vehicleId}/acceptance-documents`,
  );
};

export const acceptanceDocuments = {
  list,
};
